export const DISCUSSION_GROUP_LOCALE_ZHCHS = {
    submit: 'æäº¤',
    cancel: 'åæ¶',
    colleague: 'åäº',
    all: 'ææäººåå¯è§',
    related: 'ä»ç¸å³äººåå¯è§',
    confirm: 'ç¡®å®',
    reply: 'åå¤',
    emptyMessage: 'ææ æ°æ®',
    placeholder: 'è¯·è¾å¥å§åæç´¢',
    notEmpty: 'æäº¤åå®¹ä¸è½ä¸ºç©º',
    selectEmployee: 'éæ©åå·¥',
    next: 'ä¸çº§',
    emptySelected: 'æ¸ç©ºå·²é',
    emptyRight: 'è¯·å¨å·¦ä¾§éæ©äººå',
    allOrg: 'å¨é¨ç»ç»',
    selected: 'å·²é',
    section: 'é¨é¨',
    people: 'äººå',
    viewMore: 'æ¥çæ´å¤',
    per: 'äºº',
    pcs: 'ä¸ª',
    emptyList: 'èç³»äººä¸ºç©º',
    advancedQuery: 'é«çº§æ¥è¯¢'
};
